import type { Dict } from "../core.js";
import type { partnerConnections as vi } from "../vi/partnerConnections.js";
export const partnerConnections: Dict<typeof vi> = {
  "accountStatus.active": "Active",
  "accountStatus.suspended": "Suspended",
  "accountStatus.closed": "Closed",
  bkavConnectionScope:
    "HQ configures the shared service address. BKAV Partner GUID and token belong to each business and are configured in Bube eInvoice.",
  partyLookupSourceScope:
    "Shared tax-code lookup source for EVERY workspace: this BKAV account belongs to Bube; customers never see it and need no provider connection. Save → Test (a real tax-code lookup with the key you just entered; it cannot be activated unless it passes) → activate → bind it to EACH app that uses it (bube-einvoice, bube-shop — independent, like Tingee). bube-shop looks up with the source bound to the shop first and only asks bube-einvoice when that fails. After binding, run Test lookup below to check the hq → bube-einvoice path before opening it to users.",
  partyLookupSourceTitle: "Test tax-code lookup",
  partyLookupSourceHelp:
    "Runs one real lookup with exactly the configuration bube-einvoice currently holds (cache skipped). A new configuration shows here only once it is bound to bube-einvoice.",
  partyLookupSourceTaxCode: "Tax code",
  partyLookupSourceRun: "Test lookup",
  partyLookupSourceRunning: "Looking up…",
  partyLookupSourceInvalid: "A tax code has 10 or 12 digits (optionally with -001).",
  partyLookupSourceNotConfigured:
    "bube-einvoice has not received a lookup source with a complete Partner GUID, token and base URL, or the binding is off. Test it and bind it to bube-einvoice, then retry.",
  partyLookupSourceOk: "Source answered ({environment}, {ms} ms)",
  partyLookupSourceFound: "Found",
  partyLookupSourceNotFound: "The source works but has no such business.",
  partyLookupSourceFailedTimeout: "Timed out ({environment}, {ms} ms). Check the network path to BKAV or the base URL.",
  partyLookupSourceFailedProvider: "BKAV refused or failed ({environment}, {ms} ms, code {code}). Check the Partner GUID, token and environment.",
  partyLookupSourceName: "Name",
  partyLookupSourceAddress: "Address",
  partyLookupSourceStatus: "Status",
  editorHelp:
    "Saving creates a candidate. The serving configuration stays in use until the new version passes validation and you activate it.",
  officialSettings: "Fixed connection addresses",
  officialSettingsHelp: "Defined by the provider and selected environment; no input is needed.",

  setupSections: "Connection setup sections",
  configurationTab: "Connection settings",
  applicationsTab: "Apps using this connection",
  selectAccount: "Select provider account",
  selectConnection: "Select connection",
  connectionCount: "{count} connections",
  versionTrace: "Version creation details",
  maintenanceActions: "Disable connection and old keys",
  maintenanceHelp:
    "Use for maintenance or revocation. Each action requires a reason and confirmation of the connection name.",
  bindingsHelp:
    "Choose an activated connection for each app. The switch is a draft selection; Save assignment applies it. Enabled configuration still requires service access.",

  olderVersions: "Previous versions ({count})",
  connectionActive: "Active",
  testReport: "Test report",
  settings: "Version settings",
  accounts: "Provider accounts",
  intro: "Create a version → test → activate. Passing a test does not activate it.",
  loading: "Loading connections…",
  reload: "Reload",
  createAccount: "Add account",
  displayName: "Account name",
  purpose: "Purpose (immutable)",
  platform: "Platform — serves applications",
  lab: "Lab — Bube testing only",
  owner: "Account owner",
  ownerId: "Owner ID",
  organization: "Bube organization",
  user: "Staff member",
  team: "Team",
  createConnection: "Add connection",
  name: "Connection name",
  noAccounts: "No provider accounts yet.",
  noConnections: "No connection in this environment.",
  noVersions: "No versions yet.",
  save: "Save candidate version",
  create: "Create",
  cancel: "Cancel",
  edit: "Create new version",
  history: "Version history",
  active: "In use",
  candidate: "Candidate",
  historical: "Historical",
  certified: "Certified",
  pending: "Pending certification",
  grandfathered: "Migration certification",
  test: "Test",
  testFailed: "Latest test failed",
  activate: "Activate",
  restore: "Restore as a new version",
  cutGrace: "End grace period",
  disable: "Disable connection",
  note: "Reason (at least 5 characters)",
  typedName: "Type the connection name to confirm",
  activateEffect:
    "The selected version will serve applications. Old keys retain grace unless explicitly waived.",
  restoreEffect: "Creates a new candidate; history and the serving version remain unchanged.",
  cutEffect: "Old keys stop accepting inbound traffic through grace.",
  disableEffect: "The server rejects this while serving bindings, routes or grace remain.",
  waive: "End old-key grace immediately",
  busy: "Working…",
  failed: "The operation failed.",
  conflict: "The configuration changed. Reload and review before submitting again.",
  emptySecret: "Leave blank to keep the existing secret",
  clearSecret: "Clear secret in the new version",
  hubOnly: "HQ only",
  bindings: "Application bindings",
  activeBinding: "Active — new outbound",
  draining: "Draining — inbound / grace only",
  deadline: "Until",
  enabled: "Enabled",
  assign: "Save binding",
  choose: "Choose a connection",
  mailRoute: "Select a mail route through the gate",
  labLink: "Open lab",
  pricing: "Pricing shared by account × provider environment",
  version: "Version",
  readOnly: "You have read-only access.",
  noActive: "No version is in use",
  status: "Status",
  draft: "Draft",
  tested: "Tested, awaiting activation",
  disabled: "Disabled",
  accountState: "Account status",
};
